import { createSlice } from '@reduxjs/toolkit';

// Define the initial state using that type
const initialState = {
  liveData: null,
  tickerInfo: null,
  salesContractQuantityChart: {
    seriesBUData: [],
    seriesSEData: [],
    xAxisData: [],
    maxValue: 0,
    isLoading: false,
  },
  isShowErrorModal: false,
  showFreePackageModal: false,
  userInfo: null,
  nextAction: null,
};

export const liveSlice = createSlice({
  name: 'liveData',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    updateLiveData: (state, { payload }) => {
      state.liveData = payload;
    },
    updateTickerInfo: (state, { payload }) => {
      state.tickerInfo = payload;
    },
    updateSalesContractQuantityChart: (state, { payload }) => {
      state.salesContractQuantityChart = payload;
    },
    showErrorModal: (state) => {
      state.isShowErrorModal = true;
    },
    toggleShowFreePackageModal: (state, { payload }) => {
      state.showFreePackageModal = payload.status;
    },
    setUserInfo: (state, { payload }) => {
      state.userInfo = payload;
    },
    setNextActionData: (state, { payload }) => {
      state.nextAction = payload;
    },
  },
});

export const {
  updateLiveData,
  updateTickerInfo,
  updateSalesContractQuantityChart,
  showErrorModal,
  toggleShowFreePackageModal,
  setUserInfo,
  setNextActionData,
} = liveSlice.actions;

export default liveSlice.reducer;
